import { Link } from "react-router-dom";
import type { Movie } from "@/types";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/movie/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 影片封面`}
          title={`${movie.title} 影片推荐 91电影`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-secondary-950/85 text-background-50 rounded-md px-2 py-1">
          <i className="ri-star-fill text-accent-400 text-xs" />
          <span className="text-xs font-bold font-label">{movie.rating.toFixed(1)}</span>
        </div>
        {movie.hot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-secondary-950 text-xs font-bold rounded-md px-2 py-1">
            热映
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300" />
          <span className="truncate">{movie.region}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="text-xs bg-secondary-100 text-secondary-800 rounded px-2 py-0.5"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}